module.exports = __webpack_public_path__ + "img/recent.f43b926f.svg";